import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store/index.js";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

router.beforeEach((to, from, next) => {
  let userIsLogged = Store.state.user.userIsLogged;
  let userActiveRole = Store.getters["user/userActiveRole"];
  if (to.meta.requiresAuth && !userIsLogged) {
    next({ name: "Login" });
  } else if (
    to.meta.roleVisibility &&
    !userActiveRole.isAny(to.meta.roleVisibility)
  ) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
